<template>
  <div class="company-info">
    <div class="left-column">
      <div class="question-text">{{ $t('series.new') }}</div>
      <div class="answer-text">{{ $t('series.old') }}</div>
    </div>
    <div v-if="this.$i18n.locale === 'zh'" class="right-column">
      <div class="info-grid top-row">
        <div class="info-card">
          <div class="number">超过<span class="highlight-number">17</span>年</div>
          <div class="text">国际顶端裁床品牌</div>
          <div class="text">提供裁床设计和</div>
          <div class="text">制造服务</div>
        </div>
        <div class="info-card">
          <div class="text text-secondary">多位售后人员</div>
          <div class="number mt-2">超过<span class="highlight-number">10</span>年</div>
          <div class="text mt-2">国际品牌裁床</div>
          <div class="text">售后服务经验</div>
        </div>
        <div class="info-card">
          <div class="text text-secondary">拥有完整的，</div>
          <div class="text text-secondary mb-2">经验极其丰富的，</div>
          <div class="text text-accent">机械设计</div>
          <div class="text text-accent">电气设计</div>
          <div class="text text-accent">软件开发</div>
          <div class="text text-accent mb-2">制造和售后团队</div>
          <div class="text">独立完整，</div>
          <div class="text">自主研发，</div>
          <div class="text">无需依靠外援。</div>
        </div>
        <div class="info-card">
          <div class="number"><span class="highlight-number">22</span>年</div>
          <div class="text">自动裁床</div>
          <div class="text">鼓风机及真空系统</div>
          <div class="text">机械设计和</div>
          <div class="text">设备制造经验</div>
          <div class="text mt-3">技术背景深厚</div>
        </div>
      </div>
      <div class="info-grid bottom-row">
        <div class="info-card">
          <div class="text">熟悉并使用</div>
          <div class="highlight-text">美国&欧洲</div>
          <div class="text">制造标准制造裁床，品质等同进口顶级品牌。</div>
        </div>
        <div class="info-card">
          <div class="text text-secondary">太势工厂位于</div>
          <div class="text text-secondary">长江三角洲核心地带</div>
          <div class="text mt-2 mb-2">江苏常州市新北区</div>
          <div class="text">
            <span class="text-purple">30</span>分钟车程到达常州机场，
          </div>
          <div class="text">
            <span class="text-purple">20</span>分钟车程到达常州高铁站，
          </div>
          <div class="text">
            <span class="text-purple">49</span>分钟高铁到上海虹桥，
          </div>
          <div class="text">
            交通便利，
          </div>
          <div class="text">
            高端制造业供应链齐全。
          </div>
        </div>
        <div class="info-card">
          <div class="text">软件及电气团队</div>
          <div class="number text-pink"><span class="highlight-number">19</span>年</div>
          <div class="text">机器人及运动控制研发经验。</div>
        </div>
      </div>
    </div>
    <div v-else class="right-column">
      <img style="width: 100%" src="../static/home/support.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyInfo',
  mounted() {
    const masterTimeline = this.$gsap.timeline({
      scrollTrigger: {
        trigger: 'left-column',
        start: 'top 80%',
        end: 'bottom 0%',
        markers: false,
        // scrub: 1,
        // once: true,
        toggleActions: 'play none none reverse'
      }
    })
    masterTimeline.from('.company-info', {
      opacity: 0,
      duration: 1.5
    })
  }
}
</script>

<style scoped>
/* 基础样式 */
.company-info {
  font-family: 'TaiShifont', sans-serif;
  display: flex;
  background-color: #e0e0e0;
  padding: 30px;
  width: 80%;
  margin: 70px auto 0;
  border-radius: 15px;
  box-sizing: border-box;
}

/* 左侧列样式 */
.left-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 30px;
  margin-right: 20px;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
}

.question-text {
  font-size: clamp(1.5rem, 4vw, 42px);
  color: #0f9ed5;
  margin-bottom: 20px;
  line-height: 1.2;
  font-weight: bold;
  word-wrap: break-word; /* 防止长单词溢出 */
}

.answer-text {
  font-size: clamp(1rem, 2.5vw, 28px);
  color: #333;
  line-height: 1.4;
  word-wrap: break-word;
}

/* 右侧列样式 */
.right-column {
  flex: 3;
  width: 100%;
}

/* 网格布局 - 保持上面4个下面3个的结构 */
.info-grid {
  display: grid;
  gap: 25px;
  margin-bottom: 30px;
  width: 100%;
  box-sizing: border-box;
}

/* 顶部4个卡片布局 */
.top-row {
  grid-template-columns: repeat(4, 1fr);
}

/* 底部3个卡片布局 */
.bottom-row {
  grid-template-columns: repeat(3, 1fr);
}

/* 卡片样式 */
.info-card {
  background-color: white;
  border-radius: 10px;
  padding: 25px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  min-height: 320px; /* 改为最小高度，允许内容撑开 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  transition: all 0.3s ease;
  box-sizing: border-box;
  overflow: hidden; /* 防止内容溢出卡片 */
}

.info-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

/* 文本样式 */
.number {
  font-size: clamp(1.4em, 3vw, 1.8em);
  color: #46b1e1;
  margin-bottom: 5px;
}

.text {
  font-size: clamp(0.9em, 2vw, 1.1em);
  color: #333;
  line-height: 1.6;
  margin: 2px 0; /* 减小段落间距 */
}

/* 辅助样式类 */
.highlight-number {
  font-size: clamp(1.6em, 4vw, 2.0em);
}

.highlight-text {
  font-size: clamp(1.4em, 4vw, 2.0em);
  color: #e38bcc;
  margin: 8px 0;
}

.text-secondary {
  color: #808080;
}

.text-accent {
  color: #46b1e1;
}

.text-purple {
  color: #d984d7;
}

.text-pink {
  color: #e38bcc;
}

.mt-2 {
  margin-top: 8px !important;
}

.mt-3 {
  margin-top: 12px !important;
}

.mb-2 {
  margin-bottom: 8px !important;
}

/* 平板设备适配 (769px - 1024px) */
@media (min-width: 769px) and (max-width: 1024px) {
  .company-info {
    width: 90%;
    padding: 25px;
  }

  .top-row {
    grid-template-columns: repeat(2, 1fr);
  }

  .bottom-row {
    grid-template-columns: repeat(2, 1fr);
  }

  .bottom-row .info-card:last-child {
    grid-column: 1 / -1;
    max-width: 50%;
    margin: 0 auto;
  }

  .info-card {
    min-height: 280px;
    padding: 20px;
  }
}

/* 手机端适配 (≤ 768px) */
@media (max-width: 768px) {
  .company-info {
    flex-direction: column;
    width: 95%;
    padding: 20px 15px;
    margin: 60px auto 0;
  }

  .left-column {
    padding-right: 0;
    margin-right: 0;
    border-right: none;
    margin-bottom: 30px;
    text-align: center;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 15px;
    padding: 0;
  }

  .top-row, .bottom-row {
    grid-template-columns: 1fr;
  }

  .bottom-row .info-card:last-child {
    grid-column: auto;
    max-width: 100%;
  }

  .info-card {
    min-height: auto; /* 移动端完全由内容决定高度 */
    padding: 15px;
    width: 100%;
  }

  /* 进一步缩小移动端字体 */
  .text {
    font-size: clamp(0.8em, 2vw, 0.9em);
    line-height: 1.5;
  }
}

/* 小屏手机适配 (≤ 480px) */
@media (max-width: 480px) {
  .question-text {
    font-size: clamp(1.2rem, 5vw, 1.5rem);
  }

  .answer-text {
    font-size: clamp(0.9rem, 3vw, 1rem);
  }

  .info-card {
    padding: 12px 8px;
  }

  /* 最小屏幕上的字体优化 */
  .highlight-number {
    font-size: clamp(1.4em, 5vw, 1.6em);
  }

  .highlight-text {
    font-size: clamp(1.2em, 5vw, 1.5em);
  }
}
</style>

